export default "__VITE_ASSET__BZLe4DD___"